import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';
class ScheduleGradeAircraftLinePeriod extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      sgas_id: this.props.sgas_id,
      schedule_grade_aircraft_id: this.props.sga_id,
      schedule_id: this.props.schedule_id,
      schedule_grade_id: this.props.schedule_grade_id,
      staff_id: this.props.staff_id,
      base_id: this.props.base_id,
      edit_mode: this.props.edit_mode,
      schedule_used_regime_id_old: this.props.schedule_used_regime_id_old,
      schedule_used_regime_id: '',
    };
    this.closeModal = this.closeModal.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // Handlers
  changePeriod (event) {
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.sgas_id,
      schedule_grade_aircraft_id: this.state.schedule_grade_aircraft_id,
      schedule_grade_id: this.state.schedule_grade_id,
      schedule_id: this.state.schedule_id,
      staff_id: this.state.staff_id,
      base_id: this.state.base_id,
      schedule_used_regime_id: event,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/aeronave/periodo/alterar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.changePeriodUpdate(responseJson, self.state.sgas_id, event);
          self.closeModal();
        } else {
          self.closeModal();
          self.props.cancelChangePeriod();
          self.props.handleAlert(responseJson.message,responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.schedule_used_regime_id !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        schedule_used_regime_id_old: newProps.schedule_used_regime_id,
        schedule_used_regime_id: newProps.schedule_used_regime_id,
        sgas_id: newProps.sgas_id,
        schedule_grade_aircraft_id: newProps.schedule_grade_aircraft_id,
        schedule_id: newProps.schedule_id,
        schedule_grade_id: newProps.schedule_grade_id,
        staff_id: newProps.staff_id,
        base_id: newProps.base_id,
        loaded: 1,
      });
    }
    this.setState({edit_mode: newProps.edit_mode});
  }

  closeModal(event){
    this.setState({modal: false});
  }

  render() {
    var self = this;
    return (
  <td className={"text-center table-schedule-sticky table-schedule-main-period-" + self.props.zoom_level}>
    <RequestApi ref={'request_api'} handleLoaded={this.props.handleLoaded} />
    {self.state.edit_mode ? 
    <div>
      <input name="schedule_used_regime_id" value={this.state.schedule_used_regime_id} onChange={this.handleChange.bind(this, 'schedule_used_regime_id')} style={{width: '100%', textAlign: 'center'}} />
      <br />
      <br />
      <button className="btn btn-success btn-xs" onClick={() => this.setState({modal: true})}><i className="fa fa-check"></i></button>
    </div>
    :
    this.state.schedule_used_regime_id}


    <Modal show={this.state.modal} bsSize="large" aria-labelledby="contained-modal-title-lg">
      <Modal.Header>
        <h4 className="pull-left">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.tituloSelecioneUmaOpcao}</h4>
        <div className="clearfix"></div>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-4">
            <button className="btn btn-block btn-success" onClick={() => this.changePeriod(this.state.schedule_used_regime_id)}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.botaoAlterarAsSiglasParaOPadraoDoRegime}</button>
          </div>
          <div className="col-md-4">
            <button className="btn btn-block btn-success" onClick={() => {this.props.changePeriodSimple(self.state.sgas_id, this.state.schedule_used_regime_id); this.closeModal()}}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.botaoAlterarORegimeMantendoAsSiglas}</button>
          </div>
          <div className="col-md-4">
            <button className="btn btn-block btn-danger" onClick={() => {this.closeModal(); this.props.cancelChangePeriod()}}><i className="fa fa-fw fa-close"></i> {this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.botaoCancelar}</button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  </td>
    );
  }
}

export default ScheduleGradeAircraftLinePeriod;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeAircraftLinePeriod.js